/* eslint-disable prettier/prettier */
import { BRAND_PROFILES } from './brand-profiles';

export const environment = {
  production: false,
  brandProfiles: BRAND_PROFILES,
  apiUrlIdentity: 'https://asv-identity-backend-main.k3s.flycatchtech.in',
  apiUrlIfs: '	https://asv-ifs-backend-dev.k3s.flycatchtech.in',
  apiUrlPassenger:
    'https://asv-passenger-manifest-backend-dev.k3s.flycatchtech.in',
  apiUrlInvoice: 'https://asv-invoice-backend-main.k3s.flycatchtech.in/',
  pdfUrl: 'https://asv-pdf-generator-dev.k3s.flycatchtech.in/generate-pdf',
  cost_center: 'abc123',
  cost_center_ACMS: '100',
};
